import { createContext, useContext } from "react";
import { AccordionVariant } from "./accordion.types";

export const AccordionContext = createContext<{ isItemActive: (value: string) => boolean; variant: AccordionVariant }>({
    isItemActive: () => false,
    variant: "card",
});
export const AccordionItemContext = createContext<{ value: string }>({ value: "" });

export const useAccordionContext = () => useContext(AccordionContext);
export const useAccordionItemContext = () => useContext(AccordionItemContext);
